import React, { useState, Component } from 'react'
import { Row, Col, Button } from 'react-bootstrap'
import { Formik, Form, Field } from 'formik'
import { paymentSchema } from '../schema/payment.schema'
import { Select, Input } from '../../../../../ui/forms/formik'
import ChangeCreditCardModal from '../../modals/ChangeCreditCardModal'
import AlertModal from '../../../../../ui/modals/AlertModal'

class PaymentFormRow extends Component {
    constructor(props) {
        super(props)

        this.state = {
            enableEdit: false,
            showModal: false,
            values: {
                paymentMethod: '',
                cardDetails: ''
            }
        }
    }

    render() {
        const { showModal, enableEdit, values } = this.state;
        const { paymentMethodOptions } = this.props;

        return (
            <div className="form-row payment-form-row">
                <Formik
                    initialValues={values}
                    validationSchema={paymentSchema}
                    onSubmit={this.handleSubmitPaymentForm}
                    validateOnMount
                >{(props) => (
                    <Form className="formik">
                        <Row>
                            <Col xl={12}>
                                <h4 className="form-group-title">Payment</h4>
                            </Col>
                            <Col xl={5} lg={6}>
                                <Field
                                    name="paymentMethod"
                                    label="Payment Method"
                                    placeholder="Payment Method"
                                    component={Select}
                                    className="select select-flat select-xl"
                                    disabled={!enableEdit}
                                    options={paymentMethodOptions}
                                />
                            </Col>
                            <Col xl={5} lg={6}>
                                <Field
                                    name="cardDetails"
                                    label="Card Details"
                                    placeholder="Card Details"
                                    component={Input}
                                    className="input input-flat input-xl"
                                    disabled
                                    customError={() => (
                                        <Button
                                            variant="link"
                                            className="small-link"
                                            disabled={!enableEdit}
                                            onClick={() => this.setShowModal('card')}
                                        >Change Card</Button>
                                    )}
                                />
                            </Col>
                            <Col xl={2}>
                                {enableEdit ? (
                                    <Button
                                        size="xl"
                                        className="form-row-btn lg"
                                        variant="primary"
                                        type="submit"
                                    >Save</Button>
                                ) : (
                                        <Button
                                            size="xl"
                                            className="form-row-btn lg"
                                            variant="secondary"
                                            onClick={(e) => { e.preventDefault(); this.toggleEdit() }}
                                        >Change</Button>
                                    )}
                            </Col>
                        </Row>
                        <ChangeCreditCardModal
                            size="md"
                            show={showModal === 'card'}
                            onHide={() => this.setShowModal('')}
                            onSubmit={values => this.handleSubmitCreditCardForm(values, props)}
                        />
                    </Form>
                )}
                </Formik>
                <AlertModal
                    size="sm"
                    show={showModal === 'loading'}
                    onHide={() => this.setShowModal('success')}
                    icon={require('../../../../../../assets/svg/ils/ils-card-scan.svg')}
                    className="loading-modal mini-modal"
                    message="Verifying Card Details"
                    subtitle="Please waith while we verify your card details"
                    btnProps={{ hidden: true }}
                />
                <AlertModal
                    size="sm"
                    show={showModal === 'success'}
                    onHide={() => this.setShowModal('')}
                    icon={require('../../../../../../assets/svg/ils/ils-check.svg')}
                    message="Card Verified"
                    subtitle="You card has been verified successfully"
                    btnText="Ok, Thanks"
                    btnProps={{ variant: "link" }}
                    className="success-modal mini-modal"
                />
            </div>
        )
    }

    /**
     * Handlers
     */

    handleSubmitCreditCardForm = (values, actions) => {
        const maskedNumber = values.cardNumber.replace(/\d{4}(?= \d)/gm, "XXXX");
        actions.setFieldValue('cardDetails', maskedNumber);

        this.setState(prevState => ({
            showModal: 'loading',
            values: {
                ...prevState.values,
                cardDetails: maskedNumber
            }
        }));
    }

    handleSubmitPaymentForm = (values, actions) => {
        this.toggleEdit();

        // MAKE REQUEST
    }

    setShowModal = modal => {
        this.setState({ showModal: modal });
    }

    toggleEdit = () => {
        this.setState(prevState => ({ enableEdit: !prevState.enableEdit }));
    }

    /**
     * Props
     */

    static defaultProps = {
        paymentMethodOptions: [
            {
                label: 'Credit Card',
                value: 'credit'
            },
            {
                label: 'Debit Card',
                value: 'debit'
            }
        ]
    }
}

export default PaymentFormRow
